export default "__VITE_ASSET__4rx_NBUB__"